import { imgInputFilePicker } from "utils/utils";
import React, { useState, useEffect } from "react";
import myProfileIcon from "assets/images/my-profile.svg";
import editIcon from "assets/images/editProfile.svg";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import uploadPhoto from "assets/images/upload-photo.svg";
import heic2any from "heic2any";

export default function UploadProfilePhoto({
  handleUpload,
  value,
  prevUrl = false,
  imParentCls = false,
  showIcon = true,
  addPhoto = true,
  gallery = false,
  certificate = false,
}) {
  const [formData, setFormData] = useState();

  const [showPrevUrl, setShowPrevUrl] = useState(prevUrl);

  useEffect(() => {
    if (value) {
      setFormData(value);
    }
  }, [value]);

  const handleUploadFile = async (event) => {
    if (value) return false;
  
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
  
    const imgs = event.target.files;
    if (!imgs || imgs.length === 0) return;
  
    try {
      if (gallery) {
        let files = [];
        let previewUrls = [];
  
        for (const im of Array.from(imgs)) {
          console.log("im :>> ", im);
          let imageFile = im;
  
          const fileExtension = imageFile.name.split(".").pop().toLowerCase();
          if (
            fileExtension === "heic" ||
            fileExtension === "heif" ||
            imageFile.type === "image/heic" ||
            imageFile.type === "image/heif"
          ) {
            console.log("Converting HEIC/HEIF file to JPEG...");
            const convertedBlob = await heic2any({
              blob: imageFile,
              toType: "image/jpeg",
              quality: 0.9,
            });
  
            imageFile = new File(
              [convertedBlob],
              imageFile.name.replace(/\.(heic|heif)$/i, ".jpg"),
              { type: "image/jpeg", lastModified: Date.now() }
            );
          }
  
          const compressedBlob = await imageCompression(imageFile, options);
          const compressedFile = new File([compressedBlob], imageFile.name, {
            type: imageFile.type,
            lastModified: Date.now(),
          });
  
          const previewUrl = URL.createObjectURL(compressedFile);
  
          files.push(compressedFile);
          previewUrls.push(previewUrl);
        }

  
        handleUpload(files, previewUrls);
      } else {
        let imageFile = imgs[0];
        const fileExtension = imageFile.name.split(".").pop().toLowerCase();
  
        if (
          fileExtension === "heic" ||
          fileExtension === "heif" ||
          imageFile.type === "image/heic" ||
          imageFile.type === "image/heif"
        ) {
          console.log("Converting HEIC/HEIF file to JPEG...");
          const convertedBlob = await heic2any({
            blob: imageFile,
            toType: "image/jpeg",
            quality: 0.9,
          });
  
          imageFile = new File(
            [convertedBlob],
            imageFile.name.replace(/\.(heic|heif)$/i, ".jpg"),
            { type: "image/jpeg", lastModified: Date.now() }
          );
        }
  
        const compressedBlob = await imageCompression(imageFile, options);
        const compressedFile = new File([compressedBlob], imageFile.name, {
          type: imageFile.type,
          lastModified: Date.now(),
        });
  
        const previewUrl = URL.createObjectURL(compressedFile);
  
        if (!certificate) setFormData(previewUrl);
  
        if (handleUpload) {
          if (!certificate) setShowPrevUrl(false);
          handleUpload(compressedFile, previewUrl);
        }
      }
    } catch (error) {
      console.error("Error converting/compressing:", error);
    }
  };

  return gallery ? (
    <>
      <input
        type="file"
        onChange={handleUploadFile}
        // accept="image/x-png,image/gif,image/jpeg"
        accept="image/*, .heic"
        multiple
      />
      <div className="media boxmediablue text-white" onClick={handleUpload}>
        <img
          className="align-self-center me-3"
          src={uploadPhoto}
          alt=""
          title=""
        />
        <div className="media-body">
          <h5 className="mt-0">
            <b>Add New Photos</b>
          </h5>
        </div>
      </div>
    </>
  ) : (
    <div className="profilebox customprofilebox">
      <div className={imParentCls ? imParentCls : "userprofile "}>
        {!showIcon ? (
          <input
            type="file"
            // id="choosefile1"
            onChange={handleUploadFile}
            className={"file-input-hidden"}
            // accept="image/x-png,image/gif,image/jpeg"
            accept="image/*, .heic"
          />
        ) : (
          ""
        )}
        <img
          src={showPrevUrl ? prevUrl : formData ? formData : myProfileIcon}
          className={addPhoto ? "profileimg" : ""}
          alt=""
          title=""
        />
        {/* <label htmlFor="choosefile1"></label> */}

        {showIcon ? (
          <span
            className="editprofile customfilebx"
            // onClick={onClickPhotoUpdate}
          >
            <input
              type="file"
              onChange={handleUploadFile}
              className={"file-input-hidden"}
              // accept="image/x-png,image/gif,image/jpeg"
              accept="image/*, .heic"
            />
            <img src={editIcon} alt="" title="" />

            {/* <label htmlFor="choosefile"></label> */}
          </span>
        ) : (
          <p className="mb-0">Upload {certificate ? "Certificate" : "Photo"}</p>
        )}
      </div>
    </div>
  );
}
